import React from "react";
import FieldDescription from "../tools/FieldDescription";

interface RcsInputProps {
    checked: boolean,
    disabled?: boolean,
    errors: { [key: string]: string },
    rcs: string,
    onChange: (data: string) => void,
}

const RcsInput: React.FC<RcsInputProps> = ({
    checked,
    errors,
    rcs,
    disabled = false,
    onChange
}) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        console.log('[RcsInput] Value typed:', inputValue);

        if (/^\d{0,9}$/.test(inputValue)) {
            onChange(inputValue);
        }
    };

    const rcsFieldDescription = "Numéro RCS de la société, exemple : 955 467 946. Soyez vigilant, la récupération automatique des données de société dépend de l’INSEE et peut ne pas être à jour.";

    return (
        <>
            <label htmlFor="rcs" className="col-sm-2 col-form-label">
                RCS <strong className= "text-danger">*</strong>
            </label>

            <div className="col-sm-4">
                <input
                    className={`description-input form-control ${(checked && errors.rcs) ? 'is-invalid' : ''}`}
                    type="text"
                    id="rcs"
                    value={rcs || ""}
                    onChange={handleChange}
                    disabled={disabled}
                />
                {checked && errors.rcs && <div className="invalid-feedback">{errors.rcs}</div>}
                <FieldDescription description={rcsFieldDescription} />
            </div>
        </>
    );
};

export default RcsInput;
